<template>
    <div class="flex items-center gap-2">
        <div>
            <slot />
        </div>
        <button type="button" class="hover:text-white" :aria-expanded="show" :aria-controls="id"
            aria-label="Show hint" title="Show hint" @click="show = !show">
            <Icon name="material-symbols:info-outline" class="text-gray-400 text-md" aria-hidden="true" />
        </button>
    </div>
    <div v-if="show" :id="id" class="text-gray-400 italic text-sm mt-2 ml-0">{{ hint }}</div>
</template>

<script lang="ts">
export default {
    props: {
        hint: String,
    },
    setup() {
        return { id: `tool-hint-${useId()}` };
    },
    data() {
        return {
            show: false,
        };
    },
};
</script>
